module.exports = __webpack_public_path__ + "front/img/bj.1ccc488c.jpg";